const ProjectListData = [
	{
		id: 27,
		name: 'Eastern SaaS',
		category: 'Web Application',
		attachmentCount: 12,
		totalTask: 32,
		completedTask: 27,
		progression: 80,
		dayleft: 21,
		statusColor: "none",
		member: [
			{
				name: 'Frederick Adams',
				img: "/img/avatars/thumb-8.jpg",
				avatarColor: ""
			},
			{
				name: 'Joyce Freeman',
				img: "/img/avatars/thumb-5.jpg",
				avatarColor: ""
			},
			{
				name: 'Clayton Bates',
				img: "",
				avatarColor: "cyan"
			},
			{
				name: 'Clayton Bates',
				img: "",
				avatarColor: "cyan"
			},
		]
	},
	{
		id: 28,
		name: 'Wind Chill App',
		category: 'Mobile Application',
		attachmentCount: 5,
		totalTask: 36,
		completedTask: 15,
		progression: 45,
		dayleft: 19,
		statusColor: "none",
		member: [
			{
				name: 'Eileen Horton',
				img: "/img/avatars/thumb-1.jpg",
				avatarColor: ""
			},
			{
				name: 'Gabriel Frazier',
				img: "",
				avatarColor: "blue"
			},
		]
	},
	{
		id: 29,
		name: 'IOP Web',
		category: 'Web Backend Application',
		attachmentCount: 8,
		totalTask: 27,
		completedTask: 19,
		progression: 73,
		dayleft: 6,
		statusColor: "orange",
		member: [
			{
				name: 'Debra Hamilton',
				img: "",
				avatarColor: "gold"
			},
			{
				name: 'Stacey Ward',
				img: "",
				avatarColor: "purple"
			},
			{
				name: 'Ron Vargas',
				img: "/img/avatars/thumb-3.jpg",
				avatarColor: ""
			},
			{
				name: 'Ron Vargas',
				img: "/img/avatars/thumb-3.jpg",
				avatarColor: ""
			},
			{
				name: 'Ron Vargas',
				img: "/img/avatars/thumb-3.jpg",
				avatarColor: ""
			},{
				name: 'Ron Vargas',
				img: "/img/avatars/thumb-3.jpg",
				avatarColor: ""
			},
		]
	},
	{
		id: 30,
		name: 'Wind Chill API',
		category: 'Backend Services',
		attachmentCount: 2,
		totalTask: 15,
		completedTask: 13,
		progression: 87,
		dayleft: 2,
		statusColor: "red",
		member: [
			{
				name: 'Troy Alexander',
				img: "",
				avatarColor: "red"
			},
			{
				name: 'Lloyd Obrien',
				img: "/img/avatars/thumb-11.jpg",
				avatarColor: ""
			},
		]
	},
	{
		id: 31,
		name: 'Octonine POS',
		category: 'Backend Application',
		attachmentCount: 8,
		totalTask: 78,
		completedTask: 23,
		progression: 21,
		dayleft: 52,
		statusColor: "cyan",
		member: [
			{
				name: 'Brittany Hale',
				img: "/img/avatars/thumb-10.jpg",
				avatarColor: ""
			},
			{
				name: 'Frederick Adams',
				img: "/img/avatars/thumb-8.jpg",
				avatarColor: ""
			},
			{
				name: 'Samantha Phillips',
				img: "/img/avatars/thumb-6.jpg",
				avatarColor: ""
			},
			{
				name: 'Samantha Phillips',
				img: "/img/avatars/thumb-6.jpg",
				avatarColor: ""
			},
			{
				name: 'Samantha Phillips',
				img: "/img/avatars/thumb-6.jpg",
				avatarColor: ""
			},
		]
	},
	{
		id: 32,
		name: 'eMenu Web',
		category: 'Frontend Web Application',
		attachmentCount: 6,
		totalTask: 18,
		completedTask: 9,
		progression: 50,
		dayleft: 6,
		statusColor: "orange",
		member: [
			{
				name: 'Gabriella May',
				img: "/img/avatars/thumb-12.jpg",
				avatarColor: ""
			},
			{
				name: 'Larry Campbell',
				img: "",
				avatarColor: "blue"
			},
			{
				name: 'Phyllis Chapman',
				img: "",
				avatarColor: "gold"
			},
		]
	},
	{
		id: 33,
		name: 'Finance Reviewer APP',
		category: 'Mobile Application',
		attachmentCount: 3,
		totalTask: 26,
		completedTask: 19,
		progression: 67,
		dayleft: 14,
		statusColor: "none",
		member: [
			{
				name: 'Lee Wheeler',
				img: "/img/avatars/thumb-13.jpg",
				avatarColor: ""
			},
			{
				name: 'Ella Robinson',
				img: "/img/avatars/thumb-15.jpg",
				avatarColor: ""
			}
		]
	},
]


export default ProjectListData